



























import { PageModeMixin } from '@/main/mixins/pageMode';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { mapActionsDvm } from '@/main/pages';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { store } from '../store/edit';

export default PageModeMixin.extend({
	name: 'ZapujckaButtons',
	components: {
		DmsPdfDialog,
	},
	props: {
		storeUri: String,
		zapujckaStav: Object,
	},
	computed: {
		...genVuexComputeds(store),
		disableButton(): object {
			return {
				planpujcPa: !(!this.RozsirProtokol && this.zapujckaStav.isOtevrena) || this.isViewMode,
				najemniSmlouva: !(this.zapujckaStav.isDlouhodoba || this.zapujckaStav.isPujcena || this.zapujckaStav.isOtevrena) || this.isViewMode,
				newPZ: !(this.zapujckaStav.isDlouhodoba || this.zapujckaStav.isVracena) || this.isViewMode,
				korProtokolPa: (this.zapujckaStav.isOtevrena || this.zapujckaStav.isFakturovana) || !this.CanRozsiritStav || this.isViewMode || this.RozsirProtokol,
				skodahlasPa: false,
				kopiePredani: this.zapujckaStav.isOtevrena,
				kopiePrevzeti: this.zapujckaStav.isOtevrena || this.zapujckaStav.isPujcena || this.zapujckaStav.isDlouhodoba,
				planPujcky: !this.VozidlopaId || this.zapujckaStav.isFakturovana || this.isViewMode,
				skodaConnect: !(this.VozidlopaId && this.VyrobekvozOzn === 'C' && this.isEditMode) || this.isViewMode,
			};
		},
	},

	methods: {
		...mapActionsDvm(store.actions),
		createZakazka() {
			if (this.zapujckaStav.isDlouhodoba && !this.FaktpristDat) {
				this.FaktpristDat = new Date();
			}
			this.$emit('createZakazka');
		},
		rozsirProtokolClick() {
			this.rozsireniProtokoluCheck(); // kontrola zda na vozidlo uz existuje zaznam zapujceni
		},
	},
});
